module.exports = __webpack_public_path__ + "static/media/IconeRoboPicPay.d48f8f04.svg";